import React from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../store/store";
import { setAffiliatesLinkSidebarOpen } from "../../../../store/features/profileSlice";

export const AffiliateLinkFixedBtn = () => {
  const { t } = useTranslation(["profile"]);
  const dispatch = useAppDispatch();

  return (
    <div className="affiliate-link-fixed-btn-container">
      <div
        className="affiliate-link-fixed-btn"
        onClick={() => dispatch(setAffiliatesLinkSidebarOpen())}
      >
        {t("affiliateLink")}
      </div>
    </div>
  );
};
